import React, { useEffect, useState, useContext } from "react";
import classes from "./EnvPage.module.css";

import SearchBox from "../components/UI/SearchBox";
import SideBox from "../components/UI/SideBox";
import CurEnvList from "../components/Environment/CurEnvList";
import EnvChart from "../components/Environment/EnvChart";
import EnvMap from "../components/Environment/EnvMap";
import EnvContext from "../hooks/EnvReducer";
import AddrSearch from "../components/Common/AddrSearch";
import { koreaInfoArr } from "../utils/weatherData";
import { fetchWithTimeout } from "../utils/fetchUtil";
import {
  APIProvider,
} from "@vis.gl/react-google-maps";

const FALLBACK_REGIONS = [
  "서울특별시",
  "부산광역시",
  "대구광역시",
  "인천광역시",
  "광주광역시",
  "대전광역시",
  "울산광역시",
  "경기도",
  "강원특별자치도",
  "충청북도",
  "충청남도",
  "전북특별자치도",
  "전라남도",
  "경상북도",
  "경상남도",
  "제주특별자치도",
  "세종특별자치시",
];

const FALLBACK_ENV_MARKERS = koreaInfoArr
  .filter((info) => FALLBACK_REGIONS.includes(info.korName))
  .map((info) => ({
    lat: info.lat,
    lng: info.lng,
    station_name: info.korName,
    area: info.korName,
    addr: "데이터 호출에 실패했습니다.",
    pm25: "-",
    pm10: "-",
    o3: "-",
    data_time: "-",
    isError: true,
  }));

const fetchAllRegionsData = async () => {
  try {
    const url =`${process.env.REACT_APP_NATURE_DATA_URL}/env/getCurrentEnvList`;
    const envRes = await fetchWithTimeout(url, {
      method : 'GET',
      headers : {
        'Content-Type': 'application/json',
        'servicekey': `${process.env.REACT_APP_NATURE_DATA_API_KEY}`
      }
    });
    
    if(!envRes.ok){
      console.error(`현재 환경 데이터 호출 실패 : ${url}`);
      throw new Error();
    }

    const contentType = envRes.headers.get("content-type") || "";
    if (!contentType.includes("application/json")) {
      const responseText = await envRes.text();
      throw new Error(
        `JSON 응답이 아닙니다. content-type=${contentType}, body=${responseText.slice(0, 120)}`
      );
    }

    const envData = await envRes.json();
    const envDataList = envData?.response?.body?.items;
    if (!Array.isArray(envDataList) || envDataList.length === 0) {
      throw new Error("환경 데이터 목록이 비어 있습니다.");
    }
    return envDataList;

  } catch (error) {
    console.error(`지역별 센서 API: ${error}`);
    return FALLBACK_ENV_MARKERS;
  }
};



const EnvPage = () => {
  const [markers, setMarkers] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);
  
  const {state, dispatch} = useContext(EnvContext);
  const sideBar = state.sideBar;
  const selectedMaker = state.selectedMarker;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const envListData = await fetchAllRegionsData();
        setMarkers(Array.isArray(envListData) ? envListData : FALLBACK_ENV_MARKERS);
        dispatch({ type: "deselectMarker" });
      } catch(error){
        console.error(`측정소 목록 조회 에러: ${error}`);
        setMarkers(FALLBACK_ENV_MARKERS);
      } finally {
        setIsDataReady(true);
      }
    };
    fetchData();
    const intervalId = setInterval(fetchData, 30 * 60 * 1000); // 30분마다 데이터 업데이트 됨
    return () => clearInterval(intervalId);
  }, [dispatch]);

  const closeSideBoxHandler = () => { 
    dispatch({type:"deselectMarker"})
  }

  return (
    <div className="env-page">
      <SearchBox>
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
          <AddrSearch />
        </APIProvider>
      </SearchBox>

      <EnvMap 
        markers={markers}
        isDataReady={isDataReady}
      />

      {sideBar && 
        <SideBox 
          title={`${selectedMaker.station_name} 대기 환경 현황`} 
          date={selectedMaker.data_time} 
          addr={selectedMaker.addr}
          closeSideBox = {closeSideBoxHandler}
          >
          <h3 className={classes["side-box-sub-tit"]}>
            현재 대기 정보 
            {selectedMaker.data_ime && <span>({selectedMaker.data_time})</span>}
          </h3>
          <CurEnvList 
            data={selectedMaker}
          />
          <h3 className={classes["side-box-sub-tit"]}>미세먼지 변동 그래프</h3>
          <EnvChart
            station_name = {selectedMaker.station_name}
            // series={[
            //   { name: "PM2.5", data: [20, 50, 30, 60] },
            //   { name: "PM10", data: [15, 35, 50, 20] },
            // ]}
            // categories={["22시", "23시", "24시", "1시"]}
          />
        </SideBox>
      }
    </div>
  );
};

export default EnvPage;
